export default {
  pending: 'Pending',
  accepted: 'Accepted',
  onGoing: 'Ongoing',
  rejected: 'Rejected',
  delivered: 'Delivered',
};



// WEBPACK FOOTER //
// ../utils/labels/delivery-status.js